import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { BaseEntityResponseDto } from '@sphere/shared/domain'
import { ActivityStateRefResponseDto } from './activity-state-ref.response'
import { ActivityTypeRefResponseDto } from './activity-type-ref.response'
import { ActivityCapabilities } from '../../../interfaces/activity-capabilities.interface'
import { ActivityVisibility } from '../../../enums'
import { UserSummary } from '@sphere/user/domain'
import { TeachingAssignmentResponseDto } from './teaching-assignment-response.dto'
import { SubjectExternalSummaryDto } from './subject-external-summary.dto'
import { ClassLevelSummaryDto } from './class-level-summary.dto'
import { LessonDto } from '@sphere/school/domain'
import { UserAssignmentResponseDto } from './user-assignment-response.dto'

export class ActivityBaseResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  authorUserId!: string

  @ApiPropertyOptional({
    description: 'Propriétaire',
    type: 'object',
    properties: {
      id: { type: 'string' },
      displayName: { type: 'string', nullable: true },
      email: { type: 'string', nullable: true },
      avatarUrl: { type: 'string', nullable: true },
    },
  })
  authorUser?: UserSummary

  @ApiPropertyOptional({ type: 'string', nullable: true, description: "ID de l'établissement" })
  establishmentId!: string | null

  @ApiProperty({ enum: Object.values(ActivityVisibility) })
  visibility!: ActivityVisibility

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  publishedAt!: string | Date | null

  @ApiProperty({ type: 'string' })
  stateId!: string

  @ApiPropertyOptional({ type: () => ActivityStateRefResponseDto })
  state?: ActivityStateRefResponseDto

  @ApiProperty({ type: 'string' })
  title!: string

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description!: string | null

  @ApiPropertyOptional({ type: 'string', nullable: true })
  instructions?: string | null

  @ApiPropertyOptional({ type: [String] })
  tags?: string[] | null

  @ApiPropertyOptional({
    enum: ['VERY_EASY', 'EASY', 'MEDIUM', 'HARD', 'VERY_HARD'],
    nullable: true,
  })
  difficulty?: string | null

  @ApiPropertyOptional({ type: Number, nullable: true })
  estimatedMinutes?: number | null

  @ApiProperty({ type: 'string' })
  typeId!: string

  @ApiPropertyOptional({ type: () => ActivityTypeRefResponseDto })
  type?: ActivityTypeRefResponseDto

  @ApiPropertyOptional({ type: 'object', additionalProperties: true, description: 'Contenu de l\'activité' })
  content?: unknown

  @ApiPropertyOptional({ type: 'object', additionalProperties: true, description: 'Configuration de l\'activité' })
  config?: unknown

  @ApiPropertyOptional({ type: 'object', additionalProperties: true, description: 'Solution de l\'activité' })
  solution?: unknown

  @ApiPropertyOptional({ type: 'object', additionalProperties: true, description: 'Barème de notation' })
  gradingRubric?: unknown

  @ApiProperty({
    description: 'Fine-grained permissions for current user',
    type: 'object',
    additionalProperties: { type: 'boolean' },
  })
  capabilities!: ActivityCapabilities

  @ApiPropertyOptional({ type: () => [TeachingAssignmentResponseDto] })
  teachingAssignments?: TeachingAssignmentResponseDto[] | null

  @ApiPropertyOptional({ type: () => [UserAssignmentResponseDto] })
  userAssignments?: UserAssignmentResponseDto[] | null
  
  @ApiPropertyOptional({ type: [String] })
  lessonLinks?: string[] | null

  @ApiPropertyOptional({
    description: 'Leçons associées',
    type: () => [LessonDto],
  })
  lessons?: LessonDto[] | null

  @ApiPropertyOptional({ type: () => SubjectExternalSummaryDto })
  subjectExternal?: SubjectExternalSummaryDto | null

  @ApiPropertyOptional({ type: () => ClassLevelSummaryDto })
  classLevel?: ClassLevelSummaryDto | null
}
